import React from 'react';

import { ContentSSelectEmpretec, Title } from './style';

import LOGO_EMPRETEC_ARENA from '../../assets/arena.png';
import LOGO_EMPRETEC_RURAL from '../../assets/rural.png';
import LOGO_EMPRETEC_STARTUP from '../../assets/startup.png';
import LOGO_EMPRETEC_TRADICIONAL from '../../assets/tradicional.png';

import { BaSeShapeButton } from '@base/react';
import LOGO_EMPRETEC_ARENA_SELECTED from '../../assets/arena-selected.png';
import LOGO_EMPRETEC_TRADICIONAL_SELECTED from '../../assets/empretec-selected-tradicional.png';
import LOGO_EMPRETEC_ARENA_MOBILE_SELECTED from '../../assets/mobile-arena-selected.png';
import LOGO_EMPRETEC_RURAL_MOBILE_SELECTED from '../../assets/mobile-rural-selected.png';
import LOGO_EMPRETEC_STARTUP_MOBILE_SELECTED from '../../assets/mobile-startup-selected.png';
import LOGO_EMPRETEC_URBANO_MOBILE_SELECTED from '../../assets/mobile-urbano-selected.png';
import LOGO_EMPRETEC_RURAL_SELECTED from '../../assets/rural-selected.png';
import LOGO_EMPRETEC_STARTUP_SELECTED from '../../assets/startup-selected.png';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';
import FormPersonalData from '../form-personal-data/form-personal-data';
import FormAddress from './form-address';
import ListClasses from './list-classes';

const empreteclist = [
  {
    id: 1,
    normal: LOGO_EMPRETEC_TRADICIONAL,
    white: LOGO_EMPRETEC_TRADICIONAL_SELECTED,
    mobile: LOGO_EMPRETEC_URBANO_MOBILE_SELECTED,
  },

  {
    id: 3,
    normal: LOGO_EMPRETEC_ARENA,
    white: LOGO_EMPRETEC_ARENA_SELECTED,
    mobile: LOGO_EMPRETEC_ARENA_MOBILE_SELECTED,
  },
  {
    id: 2,
    normal: LOGO_EMPRETEC_STARTUP,
    white: LOGO_EMPRETEC_STARTUP_SELECTED,
    mobile: LOGO_EMPRETEC_STARTUP_MOBILE_SELECTED,
  },
  {
    id: 4,
    normal: LOGO_EMPRETEC_RURAL,
    white: LOGO_EMPRETEC_RURAL_SELECTED,
    mobile: LOGO_EMPRETEC_RURAL_MOBILE_SELECTED,
  },
];

function SelectEmpretecWeb({ handleMenuClick }) {
  const { isLargeDisplay } = useDisplay();

  const {
    handleSelectEmpretec,
    empretecId,
    classes,
    pageIndex,
    totalPages,
    totalItems,
    selectedUfOption,
    handleSelectClass,
    handlePageChange,
    selectedIdClass,
    personalData,
    handleChangePersonalData,
    showPersonalDataForm,
  } = React.useContext(FormContext);

  return (
    <div>
      <Title>
        <p>
          Escolha o <strong>Empretec</strong> mais adequado para você
        </p>
        <BaSeShapeButton
          size="medium"
          sizeIcon="medium"
          type="tertiary"
          color="#ffffff"
          nameIcon="exclamation-circle"
          popover={{
            direction: 'top',
            width: 200,
            renderContent: () => (
              <p
                style={{
                  fontSize: '0.8em',
                  color: '#555555',
                  lineHeight: '15px',
                }}
              >
                Quer saber qual Empretec combina com você? Confira aqui as{' '}
                <strong
                  onClick={() => handleMenuClick()}
                  style={{
                    color: '#006BFF',
                    fontSize: '1em',
                    cursor: 'pointer',
                  }}
                >
                  versões
                </strong>
                .
              </p>
            ),
          }}
        />
      </Title>
      <ContentSSelectEmpretec>
        {empreteclist.map((image, index) => (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img
            key={image.id}
            src={
              empretecId === image.id
                ? isLargeDisplay()
                  ? image.white
                  : image.mobile
                : image.normal
            }
            alt={`Image ${index + 1}`}
            onClick={() => handleSelectEmpretec(image.id)}
          />
        ))}
      </ContentSSelectEmpretec>

      {empretecId && <FormAddress />}

      <ListClasses
        classes={classes}
        handlePageChange={handlePageChange}
        pageIndex={pageIndex}
        handleSelectClass={handleSelectClass}
        selectedIdClass={selectedIdClass}
        selectedUfOption={selectedUfOption}
        totalItems={totalItems}
        totalPages={totalPages}
      />

      {showPersonalDataForm && (
        <FormPersonalData
          handleChangePersonalData={handleChangePersonalData}
          personalData={personalData}
        />
      )}
    </div>
  );
}

export default SelectEmpretecWeb;
